import { render } from "./RentalManagement.vue?vue&type=template&id=07223a36"
import script from "./RentalManagement.vue?vue&type=script&lang=js"
export * from "./RentalManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/RentalManagement/RentalManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07223a36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07223a36', __exports__)) {
    api.reload('07223a36', __exports__)
  }
  
  module.hot.accept("./RentalManagement.vue?vue&type=template&id=07223a36", () => {
    api.rerender('07223a36', render)
  })

}


export default __exports__